import { Input, Output, ViewChild, ElementRef } from '@angular/core'
import { animate, style, transition, trigger } from '@angular/animations'
import { Component, EventEmitter } from '@angular/core'
import { Live } from 'src/lib/entity/live'
import { Magazine } from 'src/lib/entity/magazine'
import { environment } from 'src/env/environment'
import { LiveUserAuthority } from 'src/lib/entity/live-user-authority'

@Component({
  selector: 'maglive-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
  animations: [
    trigger('toggleSidebar', [
      transition(':enter', [
        style({ transform: 'translateX(-100%)' }),
        animate('200ms ease-in', style({ transform: 'translateX(0%)' })),
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ transform: 'translateX(-100%)' })),
      ]),
    ]),
  ],
})
export class HeaderComponent {
  public baseURL = environment.baseURL
  public loginCallbackURL =
    environment.baseURL.mag2mypage + 'Welcome.do?ref=' + window.location.href
  public registerCallbackURL =
    environment.baseURL.mag2mypage +
    'entry/UserRegistTerms.do?ref=' +
    window.location.href

  public sidebarOpened = false

  @Input() public authority: LiveUserAuthority | 'NOT_LOGIN'
  @Input() private magazine: Magazine | string
  @Input() private live: Live | string
  @Input() public color: 'bland' | 'black' = 'bland'

  @Output() private sidebarToggleButtonClicked = new EventEmitter<void>()

  @ViewChild('backdrop', { static: false }) set content(
    backdrop: ElementRef<HTMLElement>
  ) {
    if (!backdrop) {
      return // initially setter gets called with undefined
    }
    backdrop.nativeElement.style.height =
      window.document.documentElement.scrollHeight + 'px'
  }

  @Input() following: Boolean
  @Output() follow: EventEmitter<Boolean> = new EventEmitter()

  get _magazine() {
    if (!this.magazine || typeof this.magazine === 'string') {
      return null
    }
    return this.magazine
  }

  get _live() {
    if (!this.live || typeof this.live === 'string') {
      return null
    }
    return this.live
  }

  toggleSidebar() {
    this.sidebarOpened = !this.sidebarOpened
    this.sidebarToggleButtonClicked.emit()
  }

  onFollowClick(following) {
    this.follow.emit(following)
    return false
  }
}
